import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';
import { ButtonComponent } from '@shared/components/button/button.component';

@Component({
  selector: 'modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrl: './modal-confirm.component.scss',
  imports: [CommonModule, TranslateModule, ButtonComponent],
})
export class ModalConfirmComponent {
  private modalData = toSignal(this.modalService.getActiveModal().pipe(map(modal => modal?.data)));

  title = computed(() => this.modalData()?.title ?? '');
  text = computed(() => this.modalData()?.text ?? '');
  confirmButtonText = computed(() => this.modalData()?.confirmButtonText ?? 'Confirmar');
  cancelButtonText = computed(() => this.modalData()?.cancelButtonText ?? 'Cancelar');
  showConfirmButton = computed(() => (this.confirmButtonText() ?? '').trim().length > 0);
  showCancelButton = computed(() => (this.cancelButtonText() ?? '').trim().length > 0);

  constructor(
    private modalService: ModalService<{
      title?: string;
      text?: string;
      confirmButtonText?: string;
      cancelButtonText?: string;
      confirm?: () => void;
      close?: () => void;
    }>,
  ) { }

  onClose() {
    this.modalData()?.close?.();
  }

  onConfirm() {
    this.modalData()?.confirm?.();
  }
}
